import type { PreloadFetchPolicy } from 'react-relay';

import FeatureGates from '@atlaskit/feature-gate-js-client';
import traceUFOPress from '@atlaskit/react-ufo/trace-press';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import parameters from './__generated__/ProjectPanelQuery.graphql';

type EntryPointParams = { ari: string };
const fetchPolicy: PreloadFetchPolicy = 'network-only';

const atlasProjectEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "@atlaskit-internal_@atlassian/entry-point-fixtures/ProjectPanel" */ './ProjectPanel'
			).then((mod) => mod.ProjectPanel),
		{
			moduleId: 'atlas-project-entrypoint',
		},
	),
	getPreloadProps: ({ ari }: EntryPointParams) => {
		traceUFOPress('townsquare-project-panel-opened');

		// check for M0 or greater
		const isProjectNativeIntegrationEnabled =
			FeatureGates.getExperimentValue(
				'atlassian_projects_-_native_integration',
				'releaseVersion',
				-1,
			) >= 0;

		return {
			queries: {
				queryReference: {
					parameters,
					variables: {
						ari,
						isProjectNativeIntegrationEnabled,
					},
					options: {
						fetchPolicy,
					},
				},
			},
		};
	},
});

export default atlasProjectEntryPoint;
